<template>
    <div class="border-t border-v2-gray-110 flex h-20 items-center px-6 relative shrink-0 dark:border-v2-gray-10">
        <div class="flex gap-4 items-center">
            <AppButton
                @click="handleDeleteTray"
                text="Delete Tray"
                icon="TrashCan"
                :loading="isLoading"
                :disabled="drawer.selected_tray.name === 'Favorites'"
                theme="primary"
                class="disabled:!type-primary disabled:!bg-v2-gray-100  hover:!bg-v2-gray-20 border-none"
                :tooltip='{
                    text: drawer.selected_tray.name === "Favorites" ? "Delete unavailable for \"Favorites\"" : null,
                    side: "top"
                }'
            />
            <div class="relative">
                <MoreButton
                    :tray="drawer.selected_tray"
                    :is-footer-button="true"
                />
            </div>
        </div>
    </div>
</template>

<script setup>

import {usePinsDrawer} from "@/Composables";
import {AppButton, LoadingCircle, MoreButton} from "@/Components";

const { drawer, deleteTray, isLoading } = usePinsDrawer();
const handleDeleteTray = () => {
    let prompt = window.confirm('Are you sure you want to delete this tray?');
    if(prompt && drawer.value?.selected_tray?.name) {
        deleteTray(drawer.value?.selected_tray.name);
    }
}
</script>
